import $ from "jquery"
import "@fancyapps/fancybox"
import disableScroll from "disable-scroll"

class Lightbox {
	constructor() {
		$.fancybox.defaults.lang = "de"
		this._init($.fancybox)
	}

	/**
	 * initialize lightbox
	 * @return	{Void}
	 * @private
	 * @memberof Lightbox.js
	 */
	_init() {
		this.fancybox = $("[data-fancybox]").fancybox({
			loop: true,
			hash: false,
			toolbar: true,
			fullScreen: {
				autoStart: false,
			},
			slideShow: {
				autoStart: false,
			},
			baseTpl:
				'<div class="fancybox-container" role="dialog" tabindex="-1">' +
				'<div class="fancybox-bg"></div>' +
				'<div class="fancybox-inner">' +
				'<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
				'<div class="fancybox-toolbar">{{buttons}}</div>' +
				'<div class="fancybox-navigation">{{arrows}}</div>' +
				'<div class="fancybox-stage"></div>' +
				"</div>" +
				"</div>",
			afterLoad: function (fb, item) {
				if (item.opts.caption) {
					let imageHolder = item.opts.$orig.closest(".bb-image")
					let copy = imageHolder.find(".image-caption").text()
						? '<div class="image-caption">' + imageHolder.find(".image-caption").text() + "</div>"
						: ""
					let caption = imageHolder.find(".image-copy").text()
						? '<div class="image-copy">' + imageHolder.find(".image-copy").text() + "</div>"
						: ""
					item.$content
						.remove(".fancybox-caption")
						.append('<div class="fancybox-caption fancybox-caption--custom">' + copy + caption + "</div>")
				}
			},
			animationEffect: "fade",
			buttons: [
				//"zoom",
				//"share",
				//"slideShow",
				//"fullScreen",
				//"download",
				//"thumbs",
				"close",
			],
			arrows: true,
			btnTpl: {
				// Arrows
				arrowLeft:
					'<a data-fancybox-prev class="button-gallery button-prev fancybox-button bb-icon bb-icon--chevron-left" title="{{PREV}}">' +
					"</a>",
				arrowRight:
					'<a data-fancybox-next class="button-gallery button-next fancybox-button bb-icon bb-icon--chevron-right" title="{{NEXT}}">' +
					"</a>",
				close:
					'<a data-fancybox-close class="button-close button-close--white bb-icon bb-icon--close" title="{{CLOSE}}">' +
					"</a>",
			},
			hideScrollbar: false,
			clickContent: () => {
				return false
			},
			afterShow: () => {
				disableScroll.on()
			},
			afterClose: () => {
				disableScroll.off()
			},
		})

		if ($("a[data-fancybox]").length) {
			$("a[data-fancybox]").append('<a class="button-gallery-fullscreen bb-icon bb-icon--expand"></a>')
		}
	}
}

export default Lightbox
